var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyzeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4F4D55",
    d: "M17.384 20 8.93 11.546l2.614-2.614 8.454 8.454L17.384 20ZM4.759 7.372l3.338 3.337 2.614-2.614-3.338-3.338L4.76 7.372Zm3.364 6.758-2.625-1.437-1.436-2.625-1.436 2.626L0 14.129l2.626 1.436 1.436 2.626 1.436-2.626 2.625-1.435ZM6.865 3.43l-2.22-1.213L3.433-.002 2.22 2.218 0 3.43l2.219 1.213 1.213 2.219 1.214-2.219L6.865 3.43Zm2.26 0 2.22 1.214 1.213 2.219 1.213-2.219 2.219-1.213-2.219-1.214-1.213-2.219-1.214 2.22L9.125 3.43Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeIcon);
export default __webpack_public_path__ + "static/media/analyze-icon.3df9d5a84790c0e475a22f816133f8c1.svg";
export { ForwardRef as ReactComponent };